import React, { useState, useEffect } from "react";
import "./component.css"
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import LoadingSpinner from "../../Loading/component";
import Sidebar from "../../Navigation/Sidebar/Sidebar";

export const UpdateNewFranchiseeCharges = (props) => {
  const [sortedData, setSortedData] = useState([]);
  const navigate = useNavigate();

 
  const goback = () => {
    navigate(-1);
  };


  const arrowClick = () => {
    navigate(-1);
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-div" >
          <div>
            <Sidebar />
          </div>
          <div style={{ width: "90vw", margin: "16px" }}>
            <div>
              <div style={{ display: "flex" }}>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={arrowClick}
                  src={leftArrow}
                  alt=""
                />
                <h2 style={{ marginLeft: "20px" }} className="userHeading">
                 Add Charges
                </h2>
              </div>
             
            </div>

            <div className="maptochargeDiv">
  <div className="cardContainer">
    {props.newCharges &&
      props.newCharges.map((charge, index) => (
        <Card
          key={charge.id}
          sx={{
            width: "30%", 
            minHeight: "320px",
            margin: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #ccc",
            }}
          >
            <Typography
              style={{
                textAlign: "right",
                marginRight: "16px",
                fontWeight: 500,
                height: "40px",
                padding: "10px",
                flex: 1,
              }}
            >
              Charge Name {index + 1}
            </Typography>
            <div>
              <input
                style={{
                  padding: "15px",
                  width: "20px",
                  marginLeft: "10px",
                  height: "20px",
                }}
                key={charge.id}
                type="checkbox"
                checked={props.selectedChargeIds.includes(charge.id)}
                onChange={() => props.handleCheckboxChange(charge.id)}
              />
            </div>
          </div>

          <CardContent>
            <ul>
              <li>Id: {charge.id}</li>
              <li>Name: {charge.name}</li>
              <li>Description: {charge.description}</li>
              <li>Beneficiary Type Id: {charge.beneficiaryTypeId}</li>
              <li>Deduction Type Id: {charge.deductionTypeId}</li>
              <li>Charge Type: {charge.chargeType}</li>
              <li>Value Type: {charge.valueType}</li>
              <li>Value: {charge.value}</li>
              <li>Value Min: {charge.valueMin}</li>
              <li>Value Max: {charge.valueMax}</li>
            </ul>
          </CardContent>
        </Card>
      ))}
  </div>
</div>
          </div>
       

    <Box className="backbtnaddpage">
            <Button
              style={{backgroundColor:"transparent", color:"black", border:"1px solid #ccc"}}
              onClick={goback}
            >
              Black
            </Button>

         
            <Button onClick={props.handleAddNeweMapCharges} style={{backgroundColor:"#14AE78", color:"#fff", border:"none"}}>Save</Button>
           
          </Box>
        </div>
      )}
    </>
  );
};
